export default __webpack_public_path__ + "static/media/envsensor_realtime_temperature.b6af2dac.svg";